import type { ApiTokenId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = null;

export function mapResponse(_: ApiResponse) {
  return null;
}

const endpoint = new FetchEndpoint({
  urlFactory: (tokenId: ApiTokenId) =>
    `/data/website/reset-password/${tokenId}`,
  mapResponse,
});

// Exports

export const authApiIsomorphicCheckResetPasswordToken =
  endpoint.createIsomorphicFetchFn();
